import { render, staticRenderFns } from "./CommissionSolshareSuccess.vue?vue&type=template&id=2933a73e&scoped=true"
import script from "./CommissionSolshareSuccess.vue?vue&type=script&lang=js"
export * from "./CommissionSolshareSuccess.vue?vue&type=script&lang=js"
import style0 from "./CommissionSolshareSuccess.vue?vue&type=style&index=0&id=2933a73e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2933a73e",
  null
  
)

export default component.exports